<template>
    <div class="content-page">
        <div class="tab-header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>拼团详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="margin: 20px;">
            <el-select v-model="checkStatus" placeholder="请选择" @change="statusChange">
                <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" size="medium" style="margin-left:20px;" @click="search">查询</el-button>
        </div>
        <div class="tab-content">
            <el-table
                :data="userActiveList"
                style="width: 100%"
                :max-height="550"
            >
                <el-table-column align="left" prop="openTime" label="开团时间" />
                <el-table-column align="center" prop="joinCount" label="已参与人数" width="300" />
                <el-table-column align="center" prop="targetCount" label="总人数" />
                <el-table-column align="center" prop="closeTime" label="到期时间" />
                <el-table-column align="center" prop="status" label="参团状态">
                    <template slot-scope="scope">
                        {{scope.row.status == 1 ? '组团中' : scope.row.status == 2 ? '组团超时' : scope.row.status == 100 ? '成团成功' : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="priceNow" label="金额 ( 元 )" />
                <!-- <el-table-column align="center" label="参团明细" width="300">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="lookDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <div v-show="userActiveList.length > 0" style="padding-left:15px;">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="queryInfo.row"
                :current-page="queryInfo.pageNo"
                background
                layout="total, prev, pager, next"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { getuserActivityList, getUserActivityListTotalNum } from '../api/index';
export default {
    data() {
        return {
            queryInfo: {
                pageNo: 1,
                row: 10
            },
            total: 0,
            userActiveList: [],
            statusList: [
                { value:  "", label: "全部成团状态" },
                { value:  1, label: "组团中" },
                { value:  2, label: "成团超时" },
                { value:  100, label: "成团成功" }
            ],
            checkStatus: "",
            id: ""
        }
    },
    mounted() {
        this.id = localStorage.activityId
        this.getuserActivityList(this.id)
    },
    beforeDestroy() {
        localStorage.removeItem('activityId')
    },
    methods: {
        statusChange(val) {
            this.checkStatus = val
            this.getuserActivityList(this.id, this.checkStatus)
        },
        search() {
            this.getuserActivityList(this.id, this.checkStatus)
        },
        getuserActivityList(activityId, status) {
            getuserActivityList({
                activityId: activityId,
                pageNo: this.queryInfo.pageNo,
                row: this.queryInfo.row,
                status: status
            })
            .then(res => {
                getUserActivityListTotalNum({
                    activityId: activityId,
                    pageNo: this.queryInfo.pageNo,
                    row: this.queryInfo.row
                })
                .then(res => {
                    if (res.code == 1) {
                        this.total = res.data.totalNum
                    } else {
                        this.total = 0
                    }
                })
                if (res.code == 1) {
                    this.userActiveList = res.data
                } else if (res.code == -1) {
                    this.userActiveList = []
                } else {}
            })
        },
        handleCurrentChange(val) {
            this.queryInfo.pageNo = val
            this.getuserActivityList()
        },
        lookDetail(row) {
            console.log(111)
            // this.$router.push('/groupPurchase/detail')
        }
    }
}
</script>

<style lang="less" scoped>
.content-page {
    .tab-header {
    }
    .tab-content {
        // width: calc(100vw - 280px);
        padding: 0 15px;
    }
}
</style>